<template>
    <div class="update-qwilr-template">
      <h3>Update Template</h3>
      <div class="form-group mb-4">
        <label for="qwilr-template-id" class="form-label">Qwilr Template ID</label>
        <input
          type="text"
          id="qwilr-template-id"
          class="form-control"
          v-model="qwilrTemplateId"
          disabled
      />
      </div>
      <div class="form-group mb-4">
        <label for="qwilr-template-title" class="form-label">Qwilr Template Title</label>
        <input
          type="text"
          id="qwilr-template-title"
          class="form-control"
          v-model="qwilrTemplateTitle"
          placeholder="Enter template title"
      />
      </div>
      <div class="form-group mb-4">
        <label for="description" class="form-label">Description</label>
        <textarea
          id="description"
          class="form-control"
          v-model="description"
          placeholder="Enter template description"
          rows="4"
        ></textarea>
      </div>
      <div class="form-buttons">
        <button class="btn btn-primary" @click="updateTemplate" :disabled="isBusy">
          <div v-if="isBusy">
              <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>

              Loading...
          </div>
          <div v-else>
            Update Template
          </div>
        </button>
        <button class="btn btn-secondary" @click="$emit('close')">Cancel</button>
      </div>
    </div>
  </template>
  
  <script>
  import { UpdateQwilrDefinitionElement } from '@/core/services/entities/qwilr.service'
  import { useToast } from 'vue-toastification'
  import { QwilrElementTypeId } from "@/core/constant/QwilrElementId";

  export default{
    name:"UpdateQwilrDefinitionTemplate",
    props:{
        template:{
            type:Object,
            required:true
        }
    },
    data(){
        return{
            description:'',
            qwilrTemplateId:'',
            qwilrTemplateTitle:'',
            isBusy:false
        }
    },
    methods:{
        async updateTemplate(){
            this.isBusy = true;

            setTimeout(async () => {
              if (!this.validateFields()){
                this.isBusy = false;
                return;
              } 

              const toast = useToast();
              const payload = { id:this.template.id, elementType:QwilrElementTypeId['Template'], description:this.description, title:this.qwilrTemplateTitle};
          
              await UpdateQwilrDefinitionElement(payload)
                      .then(response => {
                      if (response.status === 200) {
                          toast.success('Template updated successfully!', {
                          timeout: 2000
                          })
                          this.isBusy = false;
                          this.$emit('templateUpdated'); // Emit the event to notify the parent component
                          this.$emit('close'); // Close the lightbox after adding data stream
                      }
                      })
                      .catch(ex => {
                          this.isBusy = false;
                          const errorMessage = ex.response?.data || ex.message || "An unknown error occurred";
                          console.log(ex);
                          toast.error(`Failed to update template : ${errorMessage}`, {timeout: 2000,});
                      })
            },500)

        },
        validateFields() {
          const toast = useToast();

          if (this.qwilrTemplateTitle.trim() === '') {
            toast.error('Template title is required!', { timeout: 3000 });
            return false; 
          }

          return true; 
        }
    },
    created() {
        this.qwilrTemplateId = this.template.qwilrElementId
        this.description=this.template.description
        this.qwilrTemplateTitle=this.template.title
    }
  }
 </script>
  
  <style scoped>
  .update-qwilr-template {
    width: 600px; /* Double the size */
    height: 500px; /* Double the size */
    padding: 40px; /* Increase padding */
    background-color: #fff; /* Ensure background is white */
    border-radius: 8px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  }
  
  .form-group {
    margin-bottom: 1rem;
  }
  
  .form-label {
    display: block;
    margin-bottom: 0.5rem;
  }
  
  .form-control {
    width: 100%;
    padding: 0.5rem;
    margin-bottom: 0.5rem;
  }
  
  .form-buttons {
    display: flex;
    justify-content: space-between;
    margin-top: 1rem;
  }
  
  .btn {
    padding: 0.5rem 1rem;
  }
  
  .btn-secondary {
    background-color: #6c757d;
    color: #fff;
  }
  
  .btn-secondary:hover {
    background-color: #5a6268;
  }
  </style>
  